import { useState, useEffect } from "react";
import { BlogPost } from "../types/blogTypes";
import { getBlogPosts } from "../utils/api-communication/RestApiCli";

interface UseBlogPostsReturn {
  posts: BlogPost[];
  loading: boolean;
  error: string | null;
}

export function useBlogPosts(): UseBlogPostsReturn {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPosts = async () => {
      setLoading(true);
      setError(null);
      try {
        const response: any = await getBlogPosts(1, 100);
        if (response) {
          setPosts(response.items);
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : "Failed to fetch blog posts");
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  return { posts, loading, error };
}
